/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const TwoDotIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="24"
      viewBox="0 0 8 24"
      fill="none"
    >
      <circle cx="4" cy="4" r="4" fill="#7E92A2" />
      <circle cx="4" cy="20" r="4" fill="#7E92A2" />
    </svg>
  )
}
